// extracted by mini-css-extract-plugin
export var activityContainer = "_n3-0";
export var typingIndicatorContainer = "_n3-1";
export var typingIndicatorDot = "_n3-2";
export var wave = "_n3-3";